import { Outlet } from 'react-router-dom';
import BottomDock from './BottomDock';
import TopBar from './TopBar';
import EmailVerificationBanner from './EmailVerificationBanner';
import AnnouncementBanner from './AnnouncementBanner';
import { DashboardDateProvider } from '@/lib/dashboardDate';

export default function DashboardShell() {
  return (
    <DashboardDateProvider>
      <div className="flex flex-col h-screen bg-background-50">
        <TopBar />
        <EmailVerificationBanner />
        <AnnouncementBanner />
        <main className="flex-1 overflow-y-auto pb-32">
          <Outlet />
        </main>
        <BottomDock />
      </div>
    </DashboardDateProvider>
  );
}